/**
 * UIResource - Base class for UI elements and layouts managed by UIManager.
 * Handles registration and cleanup lifecycle with the parent manager.
 */

import type { UIManager } from './UIManager.js';

export abstract class UIResource {
  protected uiManager: WeakRef<UIManager> | null = null;

  public registerWithUIManager(uiManager: UIManager): void {
    if (this.uiManager) {
      throw new Error('UIResource already has a UIManager');
    }
    this.uiManager = new WeakRef(uiManager);
  }

  protected unregisterFromUIManager(): void {
    if (!this.uiManager) {
      return;
    }
    this.uiManager.deref()?.unregisterUIResource(this);
    this.uiManager = null;
  }
}
